export default __webpack_public_path__ + "static/media/nutricionista.55e58ee0.jpg";